import { useState } from "react";
import { initialLayer } from "../../conts/defaultValues.js";
import useVectorTile from "../vectorTiles/useVectorTile.js";
import { BUILDINGS_OPTIONS } from "../../conts/layers.js";
import useRasterTile from "../rasterTiles/useRasterTile.js";

const useMapLayers = (mapRef) => {
  const [biomass, setBiomass] = useState(initialLayer);
  const [forest, setForest] = useState(initialLayer);
  const [buildings, setBuildings] = useState(initialLayer);
  const [grassland, setGrassland] = useState(initialLayer);
  const [shrubland, setShrubland] = useState(initialLayer);
  const [relief, setRelief] = useState({ terrain: false, buildings3d: false });

  const toggleLayer = (setter) =>
    setter((prev) => ({ ...prev, show: !prev.show }));
  const toggleRelief = (key) => setRelief((r) => ({ ...r, [key]: !r[key] }));

  useVectorTile(mapRef, "buildings", 1, buildings.show, BUILDINGS_OPTIONS);
 useRasterTile(mapRef, "biomass", biomass.show);
  useRasterTile(mapRef, "forest", forest.show);
  useRasterTile(mapRef, "grassland", grassland.show);
  useRasterTile(mapRef, "shrubland", shrubland.show);
  return {
    biomass,
    forest,
    buildings,
    grassland,
    shrubland,
    relief,
    onShowBiomass: () => toggleLayer(setBiomass),
    onShowForest: () => toggleLayer(setForest),
    onShowBuildings: () => toggleLayer(setBuildings),
    onShowGrassland: () => toggleLayer(setGrassland),
    onShowShrubland: () => toggleLayer(setShrubland),
    toggleRelief,
  };
};

export default useMapLayers;
